import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './content-focus-displays.component.scss';
var ContentFocusDisplays = /** @class */ (function (_super) {
    tslib_1.__extends(ContentFocusDisplays, _super);
    function ContentFocusDisplays(element) {
        return _super.call(this, element) || this;
    }
    ContentFocusDisplays.prototype.init = function () {
    };
    ContentFocusDisplays.prototype.bindEvents = function () {
    };
    return ContentFocusDisplays;
}(Base));
export { ContentFocusDisplays };



//////////////////
// WEBPACK FOOTER
// ./components/content-focus-displays/content-focus-displays.component.ts
// module id = 231
// module chunks = 0